export default __webpack_public_path__ + "static/media/edit-order-icon.7409a0fd.svg";